import { useContext } from 'react';
import { Formik, Form } from 'formik';
import { CircleLoader, Page, PageHeader } from 'components';
import { ticketCategoryDetailsContext, ticketCategorySchema } from './TicketCategoryDetailsContext';
import { TicketCategoryForm } from './components';
import { useLocation } from 'react-router-dom';


let TicketCategoryDetails = () => {
    let router = useLocation();

    let service = useContext(ticketCategoryDetailsContext);

    let isNew = router.pathname.includes('/addnew');

    let title = isNew ? 'Nuova categoria ticket' : 'Modifica categoria ticket';

    return (
        <Page title={title}>
            <PageHeader pageTitle={title} />
            <Formik
                enableReinitialize={true}
                validationSchema={ticketCategorySchema}
                initialValues={service.ticketCategory}
                onSubmit={(values, action) => {
                    service.saveTicketCategory(values);
                    action.setSubmitting(false);
                }}
            >
                {formProps =>
                    <Form>
                        {service.isLoading && <CircleLoader />}
                        {service.isLoading === false && <TicketCategoryForm formProps={formProps} />}
                    </Form>
                }
            </Formik>
        </Page>
    );
}

export default TicketCategoryDetails;